// @ts-check
import { useEffect, useRef } from 'react';

/**
 * Checkbox for one row. `selection` is the object returned by useRowSelection.
 * Shift-click selects the range from the last toggled row.
 * @param {{ selection: any, id: string, label?: string }} props
 */
export const RowCheckbox = ({ selection, id, label = 'Select row' }) => (
  <input
    type="checkbox"
    className="rounded-lg"
    aria-label={label}
    checked={selection.isSelected(id)}
    onChange={(e) => selection.toggle(id, { shift: Boolean(/** @type {any} */ (e.nativeEvent).shiftKey) })}
  />
);

/**
 * Select-all checkbox for the table header, with the indeterminate dash when only some rows are picked.
 * @param {{ selection: any, label?: string }} props
 */
export const HeaderCheckbox = ({ selection, label = 'Select all rows' }) => {
  const ref = useRef(/** @type {HTMLInputElement | null} */ (null));
  useEffect(() => {
    if (ref.current) ref.current.indeterminate = selection.someSelected;
  }, [selection.someSelected]);
  return (
    <input
      ref={ref}
      type="checkbox"
      className="rounded-lg"
      aria-label={label}
      checked={selection.allSelected}
      onChange={selection.toggleAll}
    />
  );
};
